import { MessageBar } from '@fluentui/react-components'
import { useProjektprognosProjectInfo } from '../fetchData/queries/useProjectInfo'
import { useState } from 'react'
import styles from '../../SystemState/ErrorManagement/MessageBars/MessageBars.module.css'

export const ProjektprognosInfoBar = () => {
  const projectInfo = useProjektprognosProjectInfo().data
  const isFinalized = projectInfo?.isFinalized
  const isArchived = projectInfo?.isArchived
  const hasBuildStartConsent = projectInfo?.datesInfo?.mgmtBuildStartConsent

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showInfoBar, setShowInfoBar] = useState<boolean>(true)

  let messages: string[] = []

  if (isArchived) {
    messages.push('Projektet är arkiverat')
  }

  if (isFinalized) {
    messages.push('Projektet är slutredovisat')
  }

  if (!hasBuildStartConsent) {
    messages.push('Igångsättningsmedgivande saknas')
  }

  const mappedMessages = () => {
    return messages.map((message, index) => (
      <p className={styles.messageMargin} key={index}>
        {message}
      </p>
    ))
  }

  if (showInfoBar && mappedMessages().length > 0) {
    return <MessageBar intent="warning">{mappedMessages()}</MessageBar>
  }

  return <></>
}
